import axios from 'axios';

/**
 * The state for the brand portal which user has access to them. Each object key represent the handle of the brand portal.
 */
const state = () => ({
    brandPortals: {}
});

const mutations = {
    addBrandPortal(state, brandPortal) {
        state.brandPortals[brandPortal.handle] = brandPortal;
    }
};

const getters = {
    getBrandPortal: (state) => (handle) => state.brandPortals[handle],
    getBrandPortalLogo: (state) => (handle) => state.brandPortals[handle]?.logo
};

const actions = {
    async loadBrandPortal({ commit }, data) {
        const { handle, infUid } = data;
        if (!handle || !infUid) {
            throw new Error('cannot execute loadBrandPortal without the required parameters');
        }

        const response = await axios.get('/brands', { params: { handle, infuid: infUid } });
        const brandPortal = response?.data;

        if (brandPortal) {
            commit('addBrandPortal', brandPortal);
        }
        return brandPortal;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
